export const LookExpectations = ({stepCount, durationMinutes}) => (
  <div className="expectations size-m">
    <span>{stepCount} steps</span>
    <span>●</span>
    <span>{durationMinutes} mins</span>
  </div>
)

export const expectationsFor = ({name, productCount}) => ({
  stepCount: Math.floor(productCount * 2) - (name.length % 3),
  durationMinutes: Math.floor(productCount * 1.5) + (name.length % 4),
})
